import React from 'react'
import { CrossClientLanding } from './Landing/CrossClientLanding'
import { useZocksAuth, useZocksQuota } from '../../components/ScopedBlock/hooks'
import { CrossClientRollout } from './Rollout/CrossClientRollout'
import { useCookies } from 'react-cookie'
import { CrossClientUpsell } from './Upsell/CrossClientUpsell'
import { CrossClientUnauthorized } from './Unauthorized/CrossClientUnauthorized'
import { useGetAccountQuery } from '../../store/accountUserSettings/accountUserSettings'
import { selectAccountId } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'
import { useCrossClientPlan } from './utils/crossClientPlan'

const CROSS_CLIENT_COOKIE = 'omn8xHPqcIjch0vyFWCY'

export const CrossClient: React.FC = () => {
  const { hasQuota, isFetching: quotaIsFetching, quotaSuccess } = useZocksQuota()
  const { hasScope } = useZocksAuth()

  const accountId = useAppSelector(selectAccountId)
  const { isFetching: planIsFetching, isPlanKnown, isUltimate } = useCrossClientPlan()
  const { isLoading: accountIsLoading } = useGetAccountQuery({ accountId })

  const crossClientAvailable = hasQuota('ai.crossClientQuery.value')
  const hasCrossClientExecutePermission = hasScope('**', 'cross_client_query:execute', ['cross_client_query:admin'])

  const [cookies] = useCookies([CROSS_CLIENT_COOKIE])

  if ((!quotaSuccess && quotaIsFetching) || accountIsLoading || planIsFetching) {
    return null
  }

  const shouldShowRollout = !crossClientAvailable && !cookies[CROSS_CLIENT_COOKIE]
  const shouldShowUpsell = quotaSuccess && !crossClientAvailable && isPlanKnown && !isUltimate

  if (shouldShowUpsell) {
    return <CrossClientUpsell />
  }

  if (shouldShowRollout) {
    return <CrossClientRollout />
  }

  if (!hasCrossClientExecutePermission) {
    return <CrossClientUnauthorized />
  }

  return <CrossClientLanding />
}
